<div [formGroup]="form">
  <div class="form-spacing">
    <!-- Read-only fields -->
    <div class="row-between">
      <!-- Request Date -->
      <div class="column">
        <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
        <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
      </div>
    </div>
    <!-- Note / Dichiarazione -->
    <div class="column">
      <p
        class="text-dark italic"
        [innerHTML]="
          'selfservice-request.address-declaration.notes.label'
            | translate: { year: form.get('createdAt')?.value | date: 'yyyy' }
        "
      ></p>
    </div>
    <!-- Paese -->
    <div class="column">
      <label for="kind" class="label">
        {{ 'selfservice-request.address-update.address-state.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-select
        id="kind"
        appendTo="body"
        formControlName="kind"
        optionValue="value"
        optionLabel="label"
        [options]="addressStateOptions"
        placeholder="{{ 'selfservice-request.address-update.address-state.placeholder' | translate }}"
        class="full-width"
        (onChange)="onChangeKind()"
      ></p-select>
      @if (form.get('kind')?.invalid && form.get('kind')?.touched) {
        <small class="text-red-500 p-error">
          {{ 'selfservice-request.address-update.error.required' | translate }}
        </small>
      }
    </div>

    @if (form.get('kind')?.value === 'ITALIAN') {
      <ng-container>
        <!-- Region -->
        <div class="column">
          <label for="stateOrRegion" class="label">
            {{ 'selfservice-request.address-update.region.label' | translate }}
            <span class="mr-1 text-red-500">*</span>
          </label>
          <p-select
            id="stateOrRegion"
            appendTo="body"
            formControlName="stateOrRegion"
            [options]="regionOptions"
            placeholder="{{ 'selfservice-request.address-update.region.placeholder' | translate }}"
            class="full-width"
            (onChange)="onChangeStateOrRegion($event.value)"
          ></p-select>
          @if (form.get('stateOrRegion')?.invalid && form.get('stateOrRegion')?.touched) {
            <small class="text-red-500 p-error">
              {{ 'selfservice-request.address-update.error.required' | translate }}
            </small>
          }
        </div>

        <!-- Province -->
        <div class="column">
          <label for="provinceOrCounty" class="label">
            {{ 'selfservice-request.address-update.province.label' | translate }}
            <span class="mr-1 text-red-500">*</span>
          </label>
          <p-select
            id="provinceOrCounty"
            appendTo="body"
            formControlName="provinceOrCounty"
            [options]="provinceOptions() || []"
            optionLabel="name"
            optionValue="code"
            placeholder="{{ 'selfservice-request.address-update.province.placeholder' | translate }}"
            class="full-width"
            (onChange)="onChangeProvinceOrCountry($event.value)"
          ></p-select>
          @if (form.get('provinceOrCounty')?.invalid && form.get('provinceOrCounty')?.touched) {
            <small class="text-red-500 p-error">
              {{ 'selfservice-request.address-update.error.required' | translate }}
            </small>
          }
        </div>

        <!-- Comune -->
        <div class="column">
          <label for="city" class="label">
            {{ 'selfservice-request.address-update.town.label' | translate }}
            <span class="mr-1 text-red-500">*</span>
          </label>
          <p-select
            id="city"
            appendTo="body"
            formControlName="city"
            [options]="townOptions() || []"
            placeholder="{{ 'selfservice-request.address-update.town.placeholder' | translate }}"
            class="full-width"
          ></p-select>
          @if (form.get('city')?.invalid && form.get('city')?.touched) {
            <small class="text-red-500 p-error">
              {{ 'selfservice-request.address-update.error.required' | translate }}
            </small>
          }
        </div>
      </ng-container>
    }
  </div>
</div>
